import {CopilotContextKey} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';
import {CLCopilotContext} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';
import {ContextFormatter} from 'common/src/modules/shared/copilot/copilot.types';
import formatContextPage from 'common/src/modules/shared/copilot/utils/formatContextPage';

function formatBriefContext(
  prevContext: CLCopilotContext | null,
  currentContext: CLCopilotContext,
): string | null {
  // whether we are in the brief page
  const _briefTabFormatter: ContextFormatter = (prevContext, currentContext) =>
    formatContextPage(CopilotContextKey.Brief, 'campaign brief tab', prevContext, currentContext);

  const formatters = [_briefTabFormatter, _briefDetailsFormatter];

  return formatters
    .map((formatter) => formatter(prevContext, currentContext))
    .filter(Boolean)
    .join('\n');
}

function _briefDetailsFormatter(
  prevContext: CLCopilotContext | null,
  currentContext: CLCopilotContext,
): string | null {
  const prevBriefContext = prevContext?.entries[CopilotContextKey.Brief];
  const currentBriefContext = currentContext.entries[CopilotContextKey.Brief];

  const prevBrief = prevBriefContext?.data.brief;
  const currentBrief = currentBriefContext?.data?.brief;
  const currentBriefEmptyFields = currentBriefContext?.data?.emptyBriefFields || [];

  if (prevBrief === currentBrief || !currentBrief) {
    return null;
  }

  let msg = `The current brief is:\n${JSON.stringify(currentBrief)}`;

  if (currentBriefEmptyFields.length) {
    msg += `\nThe empty fields in the current brief are:\n${currentBriefEmptyFields.join(', ')}`;
  } else {
    msg += '\nThere are no empty fields in the current brief.';
  }

  return msg;
}

export default formatBriefContext;
